import styled from '@emotion/styled';
import { breakpoints } from '@hover/blueprint/foundation';
import React from 'react';
import SharedHero from '../components/common/shared-hero';
import TryItOut from '../components/common/try-it-out';
import Advantages from '../components/home-page/advantages';
import PartnerAppHowItWorks from '../components/home-page/how-it-works';
import PartnerLayout from '../components/layout';
import Footer from '../components/layout/footer';
import {
  PARTNER_BEACON_ADVANTAGES,
  PARTNER_BEACON_HERO_VIDEO_SRC,
  PARTNER_BEACON_HOW_IT_WORKS,
} from '../constants';

const Hero = styled(SharedHero)`
  & .shared-hero__body {
    font-size: 1.6875rem;
    line-height: 1.3em;
    font-weight: 300;
  }
  & .shared-hero__image {
    max-width: 50%;
    position: absolute;
    right: -50px;
  }
  & .shared-hero__video {
    max-height: 580px;
  }

  @media screen and (max-width: 1151px) {
    & .shared-hero__heading,
    .shared-hero__body {
      text-align: left;
    }
    & .shared-hero__heading {
      font-size: 2rem;
      line-height: 1.5rem;
    }
    & .shared-hero__image {
      z-index: -1;
      max-width: 60%;
      width: 100%;
      opacity: 0.4;
    }
    & .shared-hero__content {
      align-items: flex-start;
    }
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
    & .shared-hero__image {
      max-width: 100%;
    }
  }
`;

const index = () => (
  <PartnerLayout title="Beacon 3D+">
    <Hero
      position="relative"
      haveContentChildren
      heading="Beacon 3D+ Platform"
      body="Beacon 3D+ transforms smartphone photos of any home to a fully measured, customizable 3D model so you can save time measuring, provide an accurate estimate and help homeowners easily visualize what the final project will look like."
      openModalButtonTitle="Start Your Free Trial"
      openModalButtonLink="/signup/"
      desktopImage={
        <video autoPlay muted playsInline loop className="shared-hero__video">
          {PARTNER_BEACON_HERO_VIDEO_SRC.map(({ src, type }) => (
            <source src={src} type={type} key={type} />
          ))}
        </video>
      }
      mobileAndTabletImage={
        <video autoPlay muted playsInline loop className="shared-hero__video">
          {PARTNER_BEACON_HERO_VIDEO_SRC.map(({ src, type }) => (
            <source src={src} type={type} key={type} />
          ))}
        </video>
      }
    />

    <Advantages items={PARTNER_BEACON_ADVANTAGES} mb={24} />

    <PartnerAppHowItWorks items={PARTNER_BEACON_HOW_IT_WORKS} my={24} />

    <TryItOut
      title="Try Beacon 3D+ today"
      body="Start your free trial of Beacon 3D+ to see how the platform measures up."
      cta={{ title: 'Start Free Trial', url: './signup/' }}
      isBordered
      my={24}
    />

    <Footer />
  </PartnerLayout>
);

export default index;
